import axiosInstance from '../axios';
import { rejectError } from '../helper';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getCDNEndpoints({ commit }) {
      return axiosInstance.get('/api/3/cdn-endpoints')
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    getCDNEndpoint({ commit }, endpointId) {
      return axiosInstance.get(`/api/3/cdn-endpoints/${endpointId}`)
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    createCDNEndpoint({ dispatch }, endpointData) {
      return axiosInstance({
        method: 'POST',
        url: '/api/3/cdn-endpoints',
        data: endpointData,
      })
        .then(() => dispatch('getCDNEndpoints'))
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateCDNEndpoint({ dispatch }, endpoint) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/3/cdn-endpoints/${endpoint.id}`,
        data: endpoint,
      })
        .then(result => result.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    removeCDNEndpoint({ dispatch }, endpointId) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/3/cdn-endpoints/${endpointId}`,
      })
        .then(result => result.data)
        .catch(error => rejectError(error));
    },
  },
};
